// import react from 'react';
// import Autosuggest from 'react-autosuggest';
import classes from "./searchBox.scss";
import SceErrorBox from './ErrorBox/sceErrorBox';
import ReactHtmlParser from 'react-html-parser';
import { getLocalizedStrings} from '../../MyAccountLanding/MultipleAccount/multipleAccountLocalizedStrings';
import SearchInfoPopup from "../../Dashboard/Common/searchInfoPopup";
class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      searchInfoPopUp: false,
      saAndCaContent: props.isCA && props.isSA,
      caContent: props.isCA,
      saContent: props.isSA
    };
    this.x_btn = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_xsearch.svg';
    this.searchIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_search.svg';
    this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_infio.svg';
    this.popupRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener('click', this.handClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handClickOutside);
  }
  handClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.state.searchInfoPopUp || event.target.alt==="Close Icon" ? null : this.props.handleCloseErrorBox(false);
    }
  }
  getErrorContent = () => {
    let searchErrCASARgx = new RegExp('<span id="searchbox_invalidNumber">([^]*?)</span>', 'g');
    let searchErrCARgx = new RegExp('<span id="searchbox_invalidNumberCA">([^]*?)</span>', 'g');
    let searcErrSARgx = new RegExp('<span id="searchbox_invalidNumberSA">([^]*?)</span>', 'g');
    let searchSeeBillRgx = new RegExp('<span id="searchbox_errSeeBillSamp">([^]*?)</span>', 'g');
    if (!_.isEmpty(this.props.content)) {
      let searchErrCASA = this.props.content.dss_search_nodata.body.match(searchErrCASARgx);
      let searchErrCA = this.props.content.dss_search_nodata.body.match(searchErrCARgx);
      let searchErrSA = this.props.content.dss_search_nodata.body.match(searcErrSARgx);
      let searchSeeBill = this.props.content.dss_search_nodata.body.match(searchSeeBillRgx);
      return {
        searchContent: {
          searchErrCASAContent: searchErrCASA ? ReactHtmlParser(searchErrCASA) : "",
          searchErrCAContent: searchErrCA ? ReactHtmlParser(searchErrCA) : "",
          searchErrSAContent: searchErrSA ? ReactHtmlParser(searchErrSA) : "",
          searchSeeBillContent: searchSeeBill ? this.removeTag(searchSeeBill[0]) : "",
        }
      };
    }
  }
  seeBillContent = () => {
    let { searchContent } = this.getErrorContent();
    let seeBillLnk = searchContent.searchSeeBillContent;
    return seeBillLnk;
  }
  searchErrorContent = () => {
    let strings = getLocalizedStrings('accountsOverviewComponent'), { searchContent } = this.getErrorContent();
    let isCa = this.props.isCA, isSa = this.props.isSA;
    let errorSACA = searchContent.searchErrCASAContent[0];
    let errorCA = searchContent.searchErrCAContent[0];
    let  errorSA = searchContent.searchErrSAContent[0];
    if (isCa && isSa) {
      return errorSACA;
    } else if (isSa) {
      return errorSA;
    } else if (isCa) {
      return errorCA;
    }
  }
  handleSearchInfo = () => {
    this.setState({ searchInfoPopUp: !this.state.searchInfoPopUp });
  }
  removeTag = (initialText) => {
    const regex=/<\s*span\b[^>]*>(.*?)<\s*\/\s*span\s*>/g;
    let matches=[];
    let match;

    while ((match=regex.exec(initialText))!==null){
      matches.push(match[1]);
    }
    return matches[0];
}
  render() {
    // let strings = getLocalizedStrings('accountsOverviewComponent');
    const errorBoxJSX =  this.props.searchBarInfo.isError ? <SceErrorBox isError='true' errorMessage={this.searchErrorContent()} seeBillLnk={this.seeBillContent()} handleSearchInfo={this.handleSearchInfo} showBillLink /> : null;
    const clearIconJSX = this.props.searchBarInfo.searchText ? <div tabIndex={"0"} className={classes.sceClearSearchIcon} aria-label='Clear the search input' onKeyDown={(e)=>e.key==="Enter"?this.props.handleSearchEvents(e,'onClear'):null} onClick={(event)=>this.props.handleSearchEvents(event,'onClear')}><img src={this.x_btn} className={classes.sce_xBtn} /></div> : null;
    const isErrorClassName = this.props.searchBarInfo.isError ? classes.sceSearchBoxMBot : classes.sceSearchBorderR;
    let searchInfoPopUp = this.state.searchInfoPopUp ? <SearchInfoPopup saAndCaContent={this.state.saAndCaContent} caContent={this.state.caContent} saContent={this.state.saContent} handleSearchInfo={this.handleSearchInfo} content={this.props.content} /> : null;
    return (
      <div>
        {searchInfoPopUp}
        <div className={classes.sceSearchLabelStyle}>{this.props.searchLabel} <span><img src={this.imageInfo} tabIndex={0} onClick={this.handleSearchInfo} onKeyPress={this.handleSearchInfo} /></span></div>
      <div ref={this.popupRef} className={[classes.sce_searchBoxcontainer,isErrorClassName].join(' ')}>
        <form className={classes.sce_searchBoxDiv}>
          <input type='text' id='search_box' aria-label={this.props.placeholder} maxLength={this.props.maxLength?this.props.maxLength:12} value={this.props.searchBarInfo.searchText} onChange={(event)=>this.props.handleSearchEvents(event,'onChange')} className={classes.inputBox} placeholder={this.props.placeholder} />
          {clearIconJSX}
          <button type='submit' className={this.props.searchBarInfo.isError ? classes.sceSearchButtonError : classes.sceSearchButton} title='Search' aria-label='Search' onClick={(event)=>this.props.handleSearchEvents(event,'onSearch')}><img src={this.searchIcon} alt='search-icon' aria-label='search-icon' className={classes.sce_searchIcon} /></button>
        </form>
        {errorBoxJSX}
      </div></div>
    );
  }

}
export default SearchBox;
